import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { Report, ReportInfo } from '../models/report';

export class ReportService extends BaseService<Report> {
  override model = Report;
  override modelName = 'report';
  override modelLabel = 'Report';

  async all(): Promise<ApiListResponse<ReportInfo>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/all`,
    });

    return await this.requestList(request, ReportInfo);
  }

  async report(
    type: string,
    params: Record<string, any> = {},
  ): Promise<ApiResponse<Report>> {
    const data: Record<string, any> = { type, ...params };

    if (params.scope === 'custom') {
      data.offsetTimeZone = 0;
    }

    const query = new URLSearchParams(data).toString();

    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/build?${query}`,
    });

    return await this.requestItem(request, Report);
  }

  async exportReport(
    params: string,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/build${params}`,
    });

    return await this.request(request);
  }

  async link(
    linkPath: string,
  ): Promise<ApiResponse<Report>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}${linkPath}`,
    });

    return await this.requestItem(request, Report);
  }
}
